<template>
	<div class="wipes page">
		<h2>WIPE SCHEDULE</h2>

		<div class="calendar">
			<v-calendar is-dark :attributes="calendar" />
		</div>

		<div class="info">
			<p>Every <b>Tuesday</b> — 16:00 CET <small>(GMT+3)</small></p>
			<p>Every <b>Friday</b> — 16:00 CET <small>(GMT+3)</small></p>

			<div class="more bpwipe">BP Wipe is every <b>second</b> Friday! (Bi-Weekly)</div>
			<div class="more"><b>Forcewipe</b> is always around 20:00 CET (GMT+3)</div>
		</div>

		<div class="legend">
			<p><span class="map"></span> − Map Wipe</p>
			<p><span class="bp"></span> − BP Wipe</p>
			<p><span class="force"></span> − Force Wipe</p>
		</div>
	</div>
</template>


<script>
import moment from "moment";

export default {
	name: "Wipes",
	data() {
		var wipe_map = [];
		var wipe_bp = [];
		var wipe_force = [];
		var fridays = 1;

		var date = moment("2023-01-01T15:00:00.000Z");
		// date.subtract(1, "month");

		for (var d = 0; d < 800; d++) {
			date.add(1, "day");

			if (date.isoWeekday() == 4 && date.date() <= 7) {
				wipe_force.push(date.toDate());
			}

			if (date.isoWeekday() == 2) {
				wipe_map.push(date.toDate());
			}

			if (date.isoWeekday() == 5) {
				fridays++;

				if (date.date() <= 8 && wipe_force.length) {
					var last_force = moment(wipe_force[wipe_force.length - 1]);
					var diff = date.diff(last_force, "hours");

					if (Math.abs(diff) <= 24) {
						if (fridays >= 2) fridays = 0;
						continue;
					}
				}

				if (fridays >= 2) {
					wipe_bp.push(date.toDate());
					fridays = 0;
				} else {
					wipe_map.push(date.toDate());
				}
			}
		}

		// var date = moment("2022-03-04T15:00:00.000Z");
		// var smonth = date.month();
		// var count = 0;
		// var fridays = 0;

		// // console.log(date.startOf("month").toDate());

		// // wipe_map.push(date.toDate());

		// for (var i = 0; i < 5; i++) {
		// 	date.startOf("month").startOf("week").add(4, "days");
		// 	wipe_force.push(date.toDate());
		// 	date.add(1, "month");
		// }

		// console.log(wipe_force);

		// date = moment("2022-03-04T15:00:00.000Z");

		// while (date.month() <= 5) {
		// 	var is_friday = !!(count++ % 2);
		// 	var add = is_friday ? 3 : 4;
		// 	if (is_friday) fridays++;

		// 	date.add(add, "days");

		// 	if (is_friday && fridays >= 2) {
		// 		wipe_bp.push(date.toDate());
		// 		fridays = 0;
		// 	} else {
		// 		var skip = false;
		// 		for (var d of wipe_force) {
		// 			var last_force = moment(d);
		// 			var diff = last_force.diff(date, "hours");
		// 			if (Math.abs(diff) == 24) skip = true;
		// 		}

		// 		if (!skip) {
		// 			wipe_map.push(date.toDate());
		// 		}
		// 	}
		// }

		return {
			calendar: [
				{
					highlight: "green",
					dates: wipe_map,
				},

				{
					highlight: "red",
					dates: wipe_bp,
				},

				{
					highlight: "blue",
					dates: wipe_force,
				},
			],
		};
	},
};
</script>


<style lang="scss">
.wipes.page {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	position: relative;

	.vc-container.vc-is-dark {
		background-color: rgba(0, 0, 0, 0.5);
		border-color: rgba(0, 0, 0, 0.2);
	}

	h2 {
		position: absolute;
		left: 0px;
		top: 10px;
		right: 0px;
		text-align: center;
		font-weight: 600;
		font-size: 30px;
	}

	p {
		margin: 5px 0px;
	}

	.info {
		padding-top: 20px;
		padding-bottom: 10px;
		text-align: center;

		small {
			opacity: 0.5;
			font-weight: 400;
		}

		.more {
			opacity: 0.5;
			display: block;
			font-size: 14px;
			font-weight: 400;
			margin-top: 2px;

			&.bpwipe {
				margin-top: 20px;
			}
		}
	}

	.legend {
		position: absolute;
		right: 50px;
		top: calc(50% - 70px);
		// bottom: 0px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 12px;
		padding: 15px;
		border-radius: 8px;
		height: 100px;
		background-color: rgba(0, 0, 0, 0.2);
		border: 1px solid rgba(0, 0, 0, 0.1);
		// opacity: 0.2;

		// &:hover {
		// 	opacity: 1;
		// }

		span {
			background-color: white;
			width: 12px;
			height: 12px;
			vertical-align: middle;
			border-radius: 100%;
			display: inline-block;
			position: relative;
			top: -2px;

			&.map {
				background-color: #48bb78;
			}
			&.bp {
				background-color: #f56565;
			}
			&.force {
				background-color: #4299e1;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		h2 {
			position: initial;
			font-size: 6vw;
		}

		.legend {
			position: initial;
		}
	}
}
</style>